import React, { useState, useEffect } from "react";
import { Col, Form, Modal, Row } from "react-bootstrap";
import styles from "./DoctorInfoPop.module.scss";
import { useLocation } from "react-router-dom";

const DoctorInfoPopup = ({ showDoctorInfo, setShowDoctorInfo, doctorData }) => {
  const handlePatientInfo = () => setShowDoctorInfo(!showDoctorInfo);
  const [doctorDataObj, setDoctorDataObj] = useState();
  let location = useLocation();
  // const [profileDetails, setProfileDetails] = useState(null)
  console.log("doctorData==>", doctorData);

  useEffect(() => {
    setDoctorDataObj(doctorData);
  }, [doctorData]);

  const today = new Date().toLocaleDateString("en-US", {
    month: "long",
    day: "numeric",
    year: "numeric",
  });

  return (
    <>
      <Modal
        show={showDoctorInfo}
        onHide={handlePatientInfo}
        backdrop="static"
        keyboard={false}
        centered
        size="xl"
        className={`${styles.PatientInfoPop} PatientInfoPop`}
        scrollable="true"
      >
        <Modal.Header
          className={`${styles.header} position-relative`}
          closeButton
        >
          <Modal.Title className="font_30 font_500 text-blue text-download d-flex align-items-center gap-2 mb-0">
            {location.pathname.startsWith("/pastoral-summary")
              ? "Priest Info"
              : " Doctor Info"}
          </Modal.Title>
          <div className="flex items-center gap-10 ms-auto text-blue">
            Date: {today}
          </div>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Row className="">
              <Col md="6" className="my-2">
                <label htmlFor="" className="form-label">
                  First Name:
                </label>
                <input
                  readOnly
                  value={doctorDataObj?.first_name || ""}
                  type="text"
                  className="form-control "
                />
              </Col>
              <Col md="6" className="my-2">
                <label htmlFor="" className="form-label">
                  Last Name:
                </label>
                <input
                  readOnly
                  value={doctorDataObj?.last_name || ""}
                  type="text"
                  className="form-control "
                />
              </Col>
              <Col md="6" className="my-2">
                <label htmlFor="" className="form-label">
                  Address:
                </label>
                <input
                  readOnly
                  value={doctorDataObj?.address || ""}
                  type="text"
                  className="form-control "
                />
              </Col>
              <Col md="6" className="my-2">
                <label htmlFor="" className="form-label">
                  City:
                </label>
                <input
                  readOnly
                  value={doctorDataObj?.city || ""}
                  type="text"
                  className="form-control "
                />
              </Col>
              <Col md="6" className="my-2">
                <label htmlFor="" className="form-label">
                  State:
                </label>
                <input
                  readOnly
                  value={doctorDataObj?.state || ""}
                  type="text"
                  className="form-control "
                />
              </Col>
              <Col md="6" className="my-2">
                <label htmlFor="" className="form-label">
                  Country:
                </label>
                <input
                  readOnly
                  value={doctorDataObj?.country || ""}
                  type="text"
                  className="form-control "
                />
              </Col>
              <Col md="6" className="my-2">
                <label htmlFor="" className="form-label">
                  Phone:
                </label>
                <input
                  readOnly
                  value={doctorDataObj?.phone_no || ""}
                  type="text"
                  className="form-control "
                />
              </Col>
              <Col md="6" className="my-2">
                <label htmlFor="" className="form-label">
                  Email:
                </label>
                <input
                  readOnly
                  value={doctorDataObj?.email || ""}
                  type="text"
                  className="form-control "
                />
              </Col>
              {/* <Col md="6" className="my-2">
                <label htmlFor="" className="form-label">
                  Doctor License:
                </label>
                <input
                  readOnly
                  value={doctorDataObj?.license_number || ""}
                  type="text"
                  className="form-control "
                />
              </Col> */}
              {/* <Col md="6" className="my-2">
                <label htmlFor="" className="form-label">Doctor Signature:</label>
                <input readOnly value={(doctorDataObj?.email) || ""}  type="text" className="form-control " />
              </Col> */}
            </Row>
            <Row className=""></Row>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default DoctorInfoPopup;
